import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bell, Check } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export const NotificationBell = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const refresh = async () => {
    if (!user) return;
    try { const { data } = await api.get("/notifications"); setItems(data.items); setUnread(data.unread); }
    catch { /* ignore */ }
  };

  useEffect(() => {
    refresh();
    if (!user) return;
    const t = setInterval(refresh, 60_000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const markAllRead = async () => {
    try { await api.post("/notifications/mark-read"); refresh(); }
    catch { /* ignore */ }
  };

  if (!user) return null;
  return (
    <div className="relative" data-testid="notif-bell-wrap">
      <button onClick={() => { setOpen((o) => !o); if (!open && unread) markAllRead(); }} className="p-2 relative" aria-label="Notifications" data-testid="notif-bell">
        <Bell size={18}/>
        {unread > 0 && <span className="absolute -top-0.5 -right-0.5 bg-brand-primary text-white text-[10px] rounded-full h-4 min-w-4 px-1 inline-flex items-center justify-center" data-testid="notif-count">{unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-80 bg-white border border-brand-line shadow-xl z-50 max-h-96 overflow-auto" data-testid="notif-dropdown">
          <div className="flex items-center justify-between px-4 py-3 border-b border-brand-line">
            <p className="font-serif text-sm">Notifications</p>
            <button onClick={markAllRead} className="text-xs text-brand-primary hover:underline flex items-center gap-1"><Check size={12}/> Mark all read</button>
          </div>
          {items.length === 0 ? (
            <p className="p-6 text-center text-sm text-brand-muted">You're all caught up.</p>
          ) : (
            <ul>
              {items.map((n) => (
                <li key={n.id} className={`px-4 py-3 border-b border-brand-line text-sm ${!n.read ? "bg-brand-blush/30" : ""}`}>
                  {n.link ? (
                    <Link to={n.link} onClick={() => setOpen(false)}>
                      <p className="font-medium text-brand-ink">{n.title}</p>
                      <p className="text-brand-muted text-xs mt-0.5">{n.body}</p>
                    </Link>
                  ) : (
                    <>
                      <p className="font-medium text-brand-ink">{n.title}</p>
                      <p className="text-brand-muted text-xs mt-0.5">{n.body}</p>
                    </>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
